// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3s4ms","footer":"ModalInfo_footer__2qKv3"};